/**
 * Base Filter class that all filters should extend
 */
export class BaseFilter {
	constructor(id, label, active = false) {
		this.id = id
		this.label = label
		this.active = active
		this.type = 'base'
	}

	/**
	 * Apply the filter logic - must be implemented by subclasses
	 * @param {any} item - The item to filter
	 * @param {Object} context - Additional context for filtering
	 * @returns {boolean} - Whether the item should be included
	 */
	apply(item, context = {}) {
		throw new Error('apply() method must be implemented by subclasses')
	}

	/**
	 * Toggle filter active state
	 */
	toggle() {
		this.active = !this.active
		return this.active
	}

	/**
	 * Set filter active state
	 * @param {boolean} active 
	 */
	setActive(active) {
		this.active = active
		return this.active
	}

	/**
	 * Get filter configuration for UI rendering
	 * @returns {Object}
	 */
	getConfig() {
		return {
			id: this.id,
			label: this.label,
			active: this.active,
			type: this.type
		}
	}

	/**
	 * Serialize filter state
	 * @returns {Object}
	 */
	serialize() {
		return {
			id: this.id,
			active: this.active,
			type: this.type
		}
	}

	/**
	 * Restore filter from serialized state
	 * @param {Object} state 
	 */
	deserialize(state) {
		this.active = state.active ?? false
	}
}